var React = require('react');

function Cash (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"path-1_1_","d":"M8.396,17v-1.659C6.453,15.193,5,14.438,4,13.424l1.245-1.678\r\n\tc0.698,0.756,1.792,1.457,3.151,1.659V9.83C6.453,9.35,4.415,8.668,4.415,6.272c0-1.88,1.547-3.374,3.981-3.576V1h1.51v1.714\r\n\tc1.527,0.166,2.811,0.756,3.792,1.677l-1.245,1.604c-0.717-0.7-1.623-1.124-2.547-1.309v3.189C11.868,8.373,14,9.092,14,11.562\r\n\tc0,1.88-1.264,3.539-4.094,3.778V17H8.396z M11.736,11.766c0-0.83-0.793-1.236-1.83-1.549v3.207\r\n\tC11.207,13.24,11.736,12.484,11.736,11.766z M6.679,6.106c0,0.719,0.717,1.087,1.717,1.382V4.595\r\n\tC7.34,4.724,6.679,5.295,6.679,6.106z"}));
}

Cash.defaultProps = {"version":"1.1","fill":"#414042","id":"Layer_1","x":"0px","y":"0px","width":"18px","height":"18px","viewBox":"0 0 18 18","enableBackground":"new 0 0 18 18","xmlSpace":"preserve"};

module.exports = Cash;

Cash.default = Cash;
